var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_106305)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4H28L31.4512 7.45119C28.7772 9.13203 27 12.1085 27 15.5C27 20.7467 31.2533 25 36.5 25C37.736 25 38.9169 24.764 40 24.3345V36C40 37.0609 39.5786 38.0783 38.8284 38.8284C38.0783 39.5786 37.0609 40 36 40H16C14.9391 40 13.9217 39.5786 13.1716 38.8284C12.4214 38.0783 12 37.0609 12 36V8C12 6.93913 12.4214 5.92172 13.1716 5.17157C13.9217 4.42143 14.9391 4 16 4Z",
    fill: "#F93749"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.25C10.7402 3.25 9.53204 3.75044 8.64124 4.64124C7.75044 5.53204 7.25 6.74022 7.25 8V40C7.25 41.2598 7.75044 42.468 8.64124 43.3588C9.53204 44.2496 10.7402 44.75 12 44.75H36C37.2598 44.75 38.468 44.2496 39.3588 43.3588C40.2496 42.468 40.75 41.2598 40.75 40V23.9986C40.2716 24.2383 39.7702 24.4388 39.25 24.5959V40C39.25 40.862 38.9076 41.6886 38.2981 42.2981C37.6886 42.9076 36.862 43.25 36 43.25H12C11.138 43.25 10.3114 42.9076 9.7019 42.2981C9.09241 41.6886 8.75 40.862 8.75 40V8C8.75 7.13805 9.09241 6.3114 9.7019 5.7019C10.3114 5.09241 11.138 4.75 12 4.75H27.6893L30.8221 7.88276C31.2323 7.57652 31.668 7.30263 32.1255 7.06487L28.5303 3.46967C28.3897 3.32902 28.1989 3.25 28 3.25H12Z",
    fill: "#F93749"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 39,
    cy: 13,
    r: 7,
    fill: "#F93749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26H16",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 34H16",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18H18H16",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5918 28.7344L30.3492 24.4917L34.5918 20.2491",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5891 19.1801C27.7463 17.4202 27.4982 15.4342 27.8822 13.5211C28.2663 11.608 29.2616 9.87152 30.7184 8.57334C32.1751 7.27515 34.0143 6.48556 35.9588 6.32354C37.9034 6.16151 39.8479 6.63583 41.4994 7.67503C43.1509 8.71423 44.4199 10.262 45.1153 12.0852C45.8106 13.9083 45.8947 15.9081 45.3547 17.7831C44.8147 19.6582 43.6799 21.3069 42.1214 22.481C40.5629 23.6551 38.665 24.2908 36.7138 24.2925L30.3498 24.4904",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 10V16L40 18",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_106305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIconRed);
export default __webpack_public_path__ + "static/media/transaction-icon-red.80bb1d3af65565922ff616db23d4ce2f.svg";
export { ForwardRef as ReactComponent };